import { Heart } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-secondary/40 mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <Heart className="w-5 h-5 text-primary fill-primary" />
            <span className="font-serif text-lg font-semibold">Finding Love in Canada</span>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed max-w-sm">
            The warmest place to meet someone special — and maybe find love on TV.
          </p>
        </div>
        <div>
          <div className="text-sm font-semibold mb-3">Explore</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/apply" className="link-underline hover:text-foreground" data-testid="footer-apply">Apply to the Show</Link></li>
            <li><Link to="/profile" className="link-underline hover:text-foreground" data-testid="footer-profile">Your Profile</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold mb-3">The Show</div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            "Finding Love in Canada" is a nationwide dating series. Real people. Real stories. Real love — from Hamilton to Oakville.
          </p>
        </div>
      </div>
      <div className="border-t border-border py-6 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Finding Love in Canada. Made with <Heart className="inline w-3 h-3 text-primary fill-primary" /> in Canada.
      </div>
    </footer>
  );
}
